'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'gauge-max';
var width = 512;
var height = 512;
var aliases = ["tachometer-alt-fastest"];
var unicode = 'f626';
var svgPathData = ['M16 256a240 240 0 1 0 480 0A240 240 0 1 0 16 256zm96-16a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm48-112a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm32 224c0-35.3 28.7-64 64-64c18.8 0 35.7 8.1 47.4 21l108-75.6c3.6-2.5 8.6-1.7 11.1 2s1.7 8.6-2 11.1l-108 75.6c4.7 8.9 7.4 19.1 7.4 29.9c0 35.3-28.7 64-64 64s-64-28.7-64-64zM272 80a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm112 48a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z', 'M256 496a240 240 0 1 0 0-480 240 240 0 1 0 0 480zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm16 80a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM208 352a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm-16 0c0-35.3 28.7-64 64-64c18.8 0 35.7 8.1 47.4 21l108-75.6c3.6-2.5 8.6-1.7 11.1 2s1.7 8.6-2 11.1l-108 75.6c4.7 8.9 7.4 19.1 7.4 29.9c0 35.3-28.7 64-64 64s-64-28.7-64-64zM384 128a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM96 224a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64-96a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faGaugeMax = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;